import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DecisionReason, DecisionReasonsResponse } from '@shared/types';
import { map, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

/**
 * Service responsible for handling decision reasons API operations.
 * Fetches configurable decision reasons from the backend based on case type.
 */
@Injectable({ providedIn: 'root' })
export class DecisionReasonsService {
    private http = inject(HttpClient);
    private utilsService = inject(UtilsService);

    /**
     * Retrieves decision reasons for a specific case type.
     * @param caseType - The type of case - 'onboarding' or 'ongoing_monitoring'
     * @returns An Observable of DecisionReason array containing active reasons for the specified case type
     */
    public getDecisionReasons(
        caseType: 'onboarding' | 'ongoing_monitoring'
    ): Observable<DecisionReason[]> {
        const url = this.utilsService.buildApiUrl(
            `config/decision-reasons/?case_type=${caseType}`
        );
        return this.http
            .get<DecisionReasonsResponse>(url)
            .pipe(map((response) => response.results));
    }
}
